import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { SchoolAssessmentAPIServiceV3 } from '@protos/analysis_management/analysis.assessment.apis_connect';

export const SchoolAssessmentAPIServiceV3Client = createPromiseClient(
  SchoolAssessmentAPIServiceV3,
  lmsTransport
);
//SchoolAssessmentAPIServiceV3
export const useSchoolAssessmentAPIServiceV3ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    SchoolAssessmentAPIServiceV3,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
